export class vwTaskSchedulerCalendarFilter {
  taskTypeCode: string; // "H" Housekeeping "M" Maintenance
  groupId: number;
  dateFrom: string;
  dateTo: string;
}
